import React, { useState, useEffect } from 'react';
import styles from '../ModulosConsulta/credito.module.sass'

import { Header } from 'pages/Header'

import { useConsultaSaldoData } from 'hooks/useConsultaSaldoData'
import { usePlanesPago } from 'pages/Credito/PagarPlanes/ModulosPagarPlanes'
import { ModalError } from 'components/Error/ErrorModal'
import { Error500 } from 'components/Error/Error500'
import { useUserInfo } from 'hooks/usePersonalData'
import { VARIANTS_PER_PORTAL } from 'constants/general'

import { ProximoCorteCredito, WhatsappCredito, DisponibleFirstCredito, BotoneraSeccionCredito, CreditoDisponibleCredito, CardCreditoMessageOk, CardCreditoMessageOterStatus, useHomePage, UltimosVistos } from '../ModulosConsulta'


function ConsultaComponentMovil(props){
    const {
        dataSaldos,
        completePlanData,
        cardsService
    } = props

    const {
        escenarioHome,
        titulo,
        accountNumber,
        newType,
        cardending,
        fechaPago,
        fechaLimite,
        saldoDisponible,
        montoMinimo,
        montoLimiteCredito,
        nuevoMensaje,
        nombre,
        telefono
    } = useHomePage(dataSaldos)

    const { profileGet } = useUserInfo()

    const [ service, setService ] = useState()

    useEffect(()=>{
        // console.log('escenarioHome: ', escenarioHome)
    },[escenarioHome])

    const handleFQS = () => {
        window.location.href = '/c/preguntas-frecuentes/'
    }

    useEffect(() => {
        //console.log('service: ', service)
    }, [ service ])

    const handleMessage = ( cardsService ) => {
        if(cardsService !== undefined){
            if(service?.credit_imit === 0 && service?.new_balance_cutting === 0 && service?.saldo_faturado === 0){
                return(
                    <div className={styles.boxMessage}>
                        <div className={styles.icon}>
                            <img src='img/campana.svg' />
                        </div>
                        <div>
                            <h5>Hola {profileGet?.nombre}, </h5>
                            <p>Gracias por tu confianza en Claroshop. Hemos <strong>pausado la opción de Crédito Claroshop</strong> durante una revisión de nuestros servicios. Valoramos tu comprensión y seguimos dedicados a ofrecerte una <strong>excelente selección de productos y métodos de pago, </strong>incluyendo tarjetas de crédito, débito y PayPal.</p>
                            <br />
                            <p>Consideraremos la posibilidad de reanudar este servicio en el futuro.</p>
                            <br />
                            <p className={styles.logo}>¡Gracias por ser parte de <img src='img/claroshop.svg' /> !</p>
                        </div>
                    </div>
                )
            } else if(service?.credit_imit == 1 && service?.credit_available > 0){
                return(
                    <div className={styles.boxMessage}>
                        <div className={styles.icon}>
                            <img src='img/campana.svg' />
                        </div>
                        <div>
                            <h5>Hola {profileGet?.nombre}, </h5>
                            <p>En Claorshop valoramos profundamente tu fidelidad. Hemos pausado temporalmente el Crédito ClaroShop y observamos que tienes un saldo a favor. Si deseas un <strong>reembolso, por favor contáctanos vía WhatsApp.</strong></p>
                            <br />
                            <p>Seguimos comprometidos con ofrecerte <strong>excelentes productos y diversos métodos de pago como tarjeta de crédito o débito, PayPal, entre otras.</strong></p>
                            <br />
                            <p className={styles.logo}>¡Gracias por ser parte de <img src='img/claroshop.svg' /> !</p>
                            <br />
                            <a href={`https://api.whatsapp.com/send?phone=${VARIANTS_PER_PORTAL.sirenaNumero}&text=Quiero%20solicitar%20mi%20reembolso`} target='_blank'>
                                <div>
                                    <img src='img/newCredito/whatsapp_ico.svg' />
                                </div>
                                <div>
                                    <p>Solicitar reembolso</p>
                                </div>
                                <div><div className={styles.arrow}></div></div>
                            </a>
                        </div>
                    </div>
                )
            } else {
                return null
            }
        }
    }

    return(
        <div className={`contenido ${styles?.contenido}`}>
            <div className={styles?.contentConsultaInt}>
                <div className={`${styles?.sectionInterna} ${(escenarioHome === 3 || escenarioHome === 4)  ? styles?.orange : '' } ${(escenarioHome === 0 || escenarioHome === 1)  ? styles?.baseHeight : '' }`}>
                    <div className={styles?.creditoCS_white_logo}></div>
                    <div onClick={handleFQS} className={styles?.btnFQS}>?</div>                
                    {escenarioHome === 0
                        ?
                            <DisponibleFirstCredito 
                                saldoDisponible={ saldoDisponible }
                                titulo={ titulo }
                                accountNumber={ accountNumber }
                                newType={ newType }
                                montoMinimo={ montoMinimo }
                                escenarioHome={ escenarioHome }
                                />
                                : null
                            }

                    {escenarioHome === 8
                        ?
                            <DisponibleFirstCredito 
                                saldoDisponible={ saldoDisponible }
                                titulo={ titulo }
                                accountNumber={ accountNumber }
                                newType={ newType }
                                montoMinimo={ montoMinimo }
                                escenarioHome={ escenarioHome }
                            />
                        : null
                    }
                </div>

                {escenarioHome === 1
                    ?
                        <CardCreditoMessageOk
                            cardending={ cardending }
                        />
                    : null 
                }

                {escenarioHome >= 2 && escenarioHome <= 7
                    ?
                        <CardCreditoMessageOterStatus
                            cardending={ cardending }
                            fechaLimite={ fechaLimite }
                            fechaPago={ fechaPago }
                            montoMinimo={ montoMinimo }
                            nuevoMensaje={ nuevoMensaje }
                            escenarioHome={ escenarioHome }
                        />
                    : null 
                }
                

                {escenarioHome != 8
                    ?
                        <BotoneraSeccionCredito 
                            titulo={ titulo }
                            accountNumber={ accountNumber }
                            nombre={ nombre }
                            telefono={ telefono }
                        />
                    : null
                }

                {handleMessage(cardsService)}

                {(escenarioHome != 0 && escenarioHome != 8 && escenarioHome != 7)
                    ?
                        <CreditoDisponibleCredito
                            saldoDisponible={ saldoDisponible }
                            montoLimiteCredito={ montoLimiteCredito }
                            titulo={ titulo }
                        />
                    : null 
                }

                <ProximoCorteCredito
                    fechaPago={ fechaPago }
                    fechaLimite={ fechaLimite }
                    typeView={0}
                    escenarioHome={ escenarioHome }
                />

                <WhatsappCredito />

                <UltimosVistos
                    escenarioHome={ escenarioHome }
                />
            </div>
        </div>
    )
}


export default function ConsultarSaldoMobile(props) {
    const {
        cardsService,
        setLoad,
        errorCode
    } = props

    const [card, setCard] = useState(false);
    const { completePlanData } = usePlanesPago(card)
    const { dataSaldos, loading, upDateDataSaldos } = useConsultaSaldoData(cardsService);

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const handleCloseErrorCode = () => SetShowModal(false);

    useEffect(() => {
        if (errorCode <= 499) {
            showModalErrorCode();
        }
    }, [errorCode])


    useEffect(() => {
        setLoad(loading);
    }, [loading])

    useEffect(() => {
        if (dataSaldos && dataSaldos?.cardending && dataSaldos?.cardending != "0000") {
            setCard(dataSaldos?.cardending);
        }
    }, [dataSaldos])

    return (
        <div className="homeMobile">
            <Header type="complete" />
            {errorCode >= 500
                ? <Error500 />
                : 
                    <ConsultaComponentMovil
                        cardsService={cardsService}
                        dataSaldos={dataSaldos}
                        completePlanData={completePlanData}
                    />
            }

            {showModal &&
                <ModalError errorCode={errorCode} handleClose={handleCloseErrorCode} />
            }
        </div>
    )
}